import { useQuery, UseQueryResult } from '@tanstack/react-query'
import analyticsService from '../services/analyticsService'
import type { PagedTestAttemptResponse, TestAttemptStatus } from '../types'

interface UseStudentAttemptsParams {
  studentId: string
  status?: TestAttemptStatus
  page?: number
  size?: number
  sort?: string
}

/**
 * Hook to fetch student test attempts with pagination
 */
export function useStudentAttempts({
  studentId,
  status,
  page = 0,
  size = 10,
  sort = 'startedAt,desc',
}: UseStudentAttemptsParams): UseQueryResult<PagedTestAttemptResponse, Error> {
  return useQuery({
    queryKey: ['student-attempts', studentId, status, page, size, sort],
    queryFn: () =>
      analyticsService.getStudentAttempts(studentId, {
        status,
        page,
        size,
        sort,
      }),
    staleTime: 2 * 60 * 1000, // 2 minutes
    enabled: !!studentId,
  })
}

export default useStudentAttempts
